import React from "react";

import { AI_DASHBOARDS_VIDEO_THUMBNAIL_SRC } from "./dashboardHelpVideo";

export type AiDashboardsHelpVideoCardVariant = "sidebar" | "menu";

export interface AiDashboardsHelpVideoCardProps {
  variant?: AiDashboardsHelpVideoCardVariant;
  onDismiss: () => void;
  onWatch: () => void;
}

const thumbButtonClass =
  "relative flex min-w-0 cursor-pointer items-center justify-center overflow-hidden rounded-xl bg-white";

const playOverlayClass =
  "absolute flex h-8 w-8 items-center justify-center rounded-full bg-[#3053ff] text-white shadow-[0_8px_20px_rgba(48,83,255,0.28)]";

const watchButtonClass =
  "flex h-8 w-full cursor-pointer items-center justify-center rounded-full bg-[#3053ff] px-3 py-[7px] text-center text-[14px] font-semibold leading-[18px] text-white hover:bg-[#2746d9] hover:text-white";

const dismissButtonClass =
  "flex h-5 w-5 shrink-0 cursor-pointer items-center justify-center rounded-full bg-white text-[#727272] transition-colors hover:text-[#111215]";

const ThumbnailButton: React.FC<{ onWatch: () => void; thumbClassName?: string }> = ({
  onWatch,
  thumbClassName,
}) => (
  <button
    type="button"
    onClick={onWatch}
    className={thumbButtonClass + (thumbClassName ? ` ${thumbClassName}` : "")}
    aria-label="Watch how to use AI Dashboards"
  >
    <img
      src={AI_DASHBOARDS_VIDEO_THUMBNAIL_SRC}
      alt=""
      className="aspect-[2128/1440] w-full rounded-xl object-cover"
    />
    <span className={playOverlayClass}>
      <span className="material-icons !text-[22px]">play_arrow</span>
    </span>
  </button>
);

export const AiDashboardsHelpVideoCard: React.FC<AiDashboardsHelpVideoCardProps> = ({
  variant = "sidebar",
  onDismiss,
  onWatch,
}) => {
  if (variant === "menu") {
    return (
      <div className="rounded-md bg-[#eff4fe] p-2">
        <div className="mb-2 flex items-start justify-between gap-2">
          <p className="min-w-0 flex-1 text-left text-[14px] font-medium leading-[18px] text-[#3053ff]">
            How to use AI Dashboards
          </p>
          <button
            type="button"
            className={dismissButtonClass}
            aria-label="Dismiss AI dashboards video"
            onClick={onDismiss}
          >
            <span className="material-icons !text-[16px]">close</span>
          </button>
        </div>
        <div className="mb-2 min-w-0">
          <ThumbnailButton onWatch={onWatch} thumbClassName="w-full flex-1" />
        </div>
        <button type="button" onClick={onWatch} className={watchButtonClass}>
          Watch Now
        </button>
      </div>
    );
  }

  return (
    <div className="flex w-full items-start gap-4 rounded-md bg-[#eff4fe] p-2">
      <ThumbnailButton onWatch={onWatch} thumbClassName="flex flex-1" />

      <div className="flex w-[130px] shrink-0 flex-col justify-center gap-[10px] self-stretch">
        <div className="text-[14px] font-medium leading-[18px] text-[#3053ff]">
          How to use
          <br />
          AI Dashboards
        </div>
        <button type="button" onClick={onWatch} className={watchButtonClass}>
          Watch Now
        </button>
      </div>

      <button
        type="button"
        className={dismissButtonClass}
        aria-label="Dismiss AI dashboards video"
        onClick={onDismiss}
      >
        <span className="material-icons !text-[16px]">close</span>
      </button>
    </div>
  );
};
